export * from './src/activation-view.component';
